export default __webpack_public_path__ + "static/media/360px-220px-square-PMR-Dev-no-border.jpg.194c6613.webp";